<template>
  <v-app
    :class="isDocument ? 'document' : ''"
    class="layout-custom"
  >
    <header-nav v-if="showHeader" />
    <v-main>
      <v-container fluid >
        <router-view
          v-if="showRouterView"
          @isLoggedIn="handleShowSidebar"
          @isLoggedOut="handleHideSidebar"
        />
        <v-spacer
          v-if="showFooter"
          class="mb-12"
        />
      </v-container>
    </v-main>
    <snackbar />
    <freely-snackbar />
    <multi-snackbar />
    <driver-topic v-if="driverUser"/>
    <loading />
    <system-message-dialog />
    <footer-nav v-if="showFooter" />
    <v-dialog
      v-model="showConfigurationChangedModal"
      width="600"
      persistent
    >
      <v-card>
        <v-toolbar
          color="info"
          dark
          tile
          flat
        >
          更新通知
        </v-toolbar>
        <v-card-text>
          <h3 class="pt-6">
            設定の更新を確認しました。<br />
            更新ボタンをクリック、またはリロードしてください。
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="info"
            @click="reloadButtonClickEvent"
          >
            更新
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <VueScriptComponent
      v-if="['production', 'staging'].includes(environment) && driverUser && me"
      :script="`<script nonce='2726c7f26c'>fs.clear();fs.show('${fullStarUUID}', '${me.id}', { company_name: '${me.company_name}', user_name: '${me.name}', user_email: '${me.email}', plan_name: '${me.plan}', tags: '' });fs.tracking();fs.survey();fs.guide();fs.checklist();fs.tooltip();</script>`"

    />
    <!-- Microsoft Clarity -->
    <VueScriptComponent
      v-if="['production', 'staging'].includes(environment) && driverUser && me && !!clarityKey"
      :script="`<script nonce='2726c7f26c' type='text/javascript'>(function(c,l,a,r,i,t,y){ c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)}; t=l.createElement(r);t.async=1;t.src='https://www.clarity.ms/tag/'+i; y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y); })(window, document, 'clarity', 'script', '${clarityKey}');</script>`"
    />
    <!-- /Microsoft Clarity -->

    <VueScriptComponent
      v-if="['production', 'staging'].includes(environment) && enableAiComponent"
      :script="`<script nonce='2726c7f26c'>window.sincloData = window.sincloData || [];function sinclo() { sincloData.push(arguments) }sinclo('config', 'dx-e')</script>`"
    />

    <!-- HM TAG -->
    <VueScriptComponent
      v-if="['production', 'staging'].includes(environment) && !!hihiTagCode"
      :script="`<script nonce='2726c7f26c' type='text/javascript'>!function(){var t=Date.now().toString();if(/[?&]hm_ct=${hihiTagCode}/.test(location.search)){var e=document.createElement('script');e.type='text/javascript',e.src='https://contents-lb01.hm-f.jp/common_tag.js?t='+t,e.async=!0,document.head.appendChild(e)}}();</script>`"
    />
    <VueScriptComponent
      v-if="['production', 'staging'].includes(environment) && !!hihiTagCode"
      :script="`<script nonce='2726c7f26c' type='module'>import haihaiInquiryPopupClient from 'https://form-gw.hm-f.jp/js/haihai.inquiry_popup.client.js';haihaiInquiryPopupClient.create({baseUrl:'https://form-gw.hm-f.jp', commonTagCode:'${hihiTagCode}'});</script>`"
    />
    <!-- /HM TAG -->


  </v-app>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

import Loading   from '../components/Loading'
import systemMessageDialog from "../components/SystemMessageDialog";
import Snackbar  from '../components/Snackbar'
import FreelySnackbar from "../components/FreelySnackbar.vue";
import FooterNav from './components/FooterNav'
import HeaderNav from './components/HeaderNav'
import VueScriptComponent from 'vue-script-component'
import MultiSnackbar from "@/components/MultiSnackbar.vue";
import DriverTopic from "./components/DriverTopic.vue";

export default {
  name: 'App',
  components: {
    MultiSnackbar,
    systemMessageDialog,
    Loading,
    Snackbar,
    FreelySnackbar,
    HeaderNav,
    FooterNav,
    VueScriptComponent,
    DriverTopic,
  },
  data () {
    return {
      environment: process.env.VUE_APP_ENV,
      fullStarUUID: process.env.VUE_APP_FULLSTAR_UUID,
      clarityKey: process.env.VUE_APP_CLARITY_CLIENT_KEY,
      hihiTagCode: process.env.VUE_APP_HIHI_TAG_CODE,
      configurationId: null,
      showConfigurationChangedModal: false,
      normalizedFrequencyMinutes: 1,
      showRouterView: true,
      showSidebar: true,
      showHeader: true,
      showFooter: true,
      isDocument: false,
      me: null,
      enableAiComponent: true,
    }
  },
  computed: {
    ...mapGetters('DriverAuthentication', [
      'driverUser',
      'tenantId',
    ]),
    ...mapGetters('DriverTenantConfiguration', [
      'enableAllocate'
    ])
  },
  watch: {
    '$route.name': function (newValue) {
      this.componentController()
    },
    /**
     * テナントIDの切り替え
     * テナントIDがnullの場合は何もしない
     * DashBoardにいる状態ではDashboardに遷移できないため
     */
    tenantId (newValue) {
      if (newValue !== null) {
        this.fetchConfiguration()
        let self = this;
        this.searchMe(function(jw_mode, use_initial_password, needs_changing_password) {

          let homeName = ['DriverDashboard']
          if (jw_mode) {
            homeName = ['DriverManifestManagements']
          }

          if (use_initial_password || needs_changing_password) {
            self.$router.replace({name: 'DriverInitialPasswordEdit'})
          } else {
            if (homeName.includes(self.$route.name)) {
              self.showRouterView = false
              self.$nextTick(() => {
                self.showRouterView = true
              })
            } else {
              if (jw_mode) {
                self.$router.replace({ name: 'DriverManifestManagements' })
              } else {
                self.$router.replace({ name: 'DriverDashboard' })
              }
            }
          }
        })
      }
    },
    enableAllocate () {
      this.enableAllocateChangeEvent()
    },
  },
  created() {
    this.componentController()
    this.searchTenantConfiguration()
    this.searchMe()
    setInterval(this.searchTenantConfiguration, 1000 * 60 * this.normalizedFrequencyMinutes)
  },
  mounted() {
    /** @typedef document */
    document.title = 'DXE Station'
  },
  beforeMount() {
    if (['DriverOrderConfirmationSlips', 'DriverManifestConfirmationSlips', 'DriverOrderConfirmationLists', 'DriverManifestConfirmationLists', 'DriverJwnetEdiApplicationForms', 'DriverJwnetJoinApplicationForms'].includes(this.$route.name)) {
      this.enableAiComponent = false;
    } else if (this.$vuetify.breakpoint.xsOnly) {
      this.enableAiComponent = false;
    } else {
      this.enableAiComponent = true
    }
  },
  methods: {
    ...mapActions('DriverMe', {
      fetchMe: 'show'
    }),
    ...mapActions('DriverTenantConfiguration', {
      'fetchConfiguration': 'show',
    }),
    ...mapActions('freelySnackbar', {
      showInfo: 'showInfo'
    }),
    componentController () {
      let header_footer_less_components = ['DriverForget', 'DriverInvitations', 'DriverOrderConfirmationSlips', 'DriverManifestConfirmationSlips', 'DriverOrderConfirmationLists', 'DriverManifestConfirmationLists', 'DriverJwnetEdiApplicationForms', 'DriverJwnetJoinApplicationForms']
      let sidebar_less_components = ['DriverInitialPasswordEdit']
      if (header_footer_less_components.includes(this.$route.name)) {
        this.showSidebar = false
        this.showHeader = false
        this.showFooter = false
        this.isDocument = ['DriverOrderConfirmationSlips', 'DriverManifestConfirmationSlips', 'DriverOrderConfirmationLists', 'DriverManifestConfirmationLists', 'DriverJwnetEdiApplicationForms', 'DriverJwnetJoinApplicationForms'].includes(this.$route.name)
      } else if (sidebar_less_components.includes(this.$route.name)) {
        this.showSidebar = false
        this.showHeader = true
        this.showFooter = true
      } else {
        this.showSidebar = true
        this.showHeader = true
        this.showFooter = true
      }
    },
    handleShowSidebar: function() {
      this.showSidebar = true
    },
    handleHideSidebar: function() {
      this.showSidebar = false
    },
    searchTenantConfiguration () {
      if (this.tenantId) {
        this.fetchConfiguration()
      }
    },
    searchMe (func) {
      this.me = null
      if (this.driverUser) {
        this.fetchMe().then((content) => {
          this.me = content
          if (func !== undefined) {
            func(this.me.jw_mode, this.me.use_initial_password, this.me.needs_changing_password)
          }
        })
      }
    },
    enableAllocateChangeEvent () {
      if (this.$route.name === 'DriverAllocationPlans' && !this.enableAllocate) {
        this.showConfigurationChangedModal = true
      }
    },
    reloadButtonClickEvent () {
      this.showConfigurationChangedModal = false
      this.$router.replace({ name: 'DriverDashboard' }, () => {})
    }
  },
}
</script>

<style lang="scss">

.ellipsis-text {
  white-space:nowrap;
  width: 100%;
  overflow:hidden;
  text-overflow:ellipsis;
}

.panel-header-color {
  color: #0D74BA !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;
      &::before {
        color: #0D74BA !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #DCE7EB;
}

// グローバルスタイルを設定
#app {
  min-height: 100vh;
  background-color: #FAFAFA;
  color: #555555;
  &.document {
    background-color: #FFFFFF;
  }
}
.main-card {
  background-color: #FAFAFA !important;
}
.fill-width {
  width: 100% !important;
}
.rounded-card{
  border-radius: 15px !important;
  &::before {
    border-radius: 15px !important;
  }
}

.sideMenuSelected {
  background-color: #FAFAFA !important;
  & .v-list-item__title, .v-list-item__icon {
    color: #0074BA !important;
  }
}

// 入力項目チックな表示項目を再現
//<div class="fieldsetLabel">
//  <fieldset>
//    <legend>ラベル</legend>
//    <span>表示値&nbsp;</span>
//  </fieldset>
//</div>
.fieldsetLabel {
  fieldset {
    width: 99%;
    background-color: #f6f6f6;
    padding-left: 8px;
    padding-right: 8px;
    border-width: thin;
    border-radius: 5px;
    border-color: rgba(0,0,0,.38);
    & legend {
      color: rgba(0,0,0,.6);
      font-size: 90%;
    }
    & span {
      display: inline-block;
      width: 100%;
      padding: 0 5px 0 5px;
      margin-bottom: 10px;
      &.number {
        text-align: right;
      }
    }
  }

  .v-label--active {
    transform: translateY(-28px) scale(1) !important;
    font-size: 12px !important;
    padding-right: 8px;
    background-color: white;
  }

}

.dialogDateTimePicker {
  & .datetimepicker {
    &.flex {
      &.visible {
        position: fixed;
        bottom: inherit !important;
      }
    }
  }
}

ul.list-unstyled {
  list-style: none;
}


dl.is {
  margin-top: 0;
  margin-bottom: 20px;
  dt {
    float: left;
    width: 180px;
    overflow: hidden;
    clear: left;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 700;
  }
  dd {
    margin-left: 250px;
  }
}

.toggleButton {
  box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
  .v-btn {
    background-color: #fff !important;
    &.v-item--active {
      color: #0D74BA !important;
      background-color: #DCE7EB !important;
      font-weight: bold;
    }
  }
}

.tableDisabledField {
  color: #0D74BA !important;
  background-color: #ddd;
}

.v-tooltip__content {
  opacity: 1!important;
  background-color: #ffffff !important;
  border: 1px solid #dddddd !important;
  color: #565656 !important;
}

// 一覧系画面のfont-sizeを小さく調整
.v-data-table,
.v-data-table__wrapper,
.v-data-table th,
.v-data-table td {
  font-size: .805rem !important;
  padding: 0 6px !important;
}

.v-autocomplete .v-input__append-outer {
  margin-top: 3px !important;
}


</style>
